import Vue from 'vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import { Loading } from 'element-ui';
import App from './App.vue';
import axios from 'axios';
import Eachats from 'echarts';
import Config from './config/config.js';
import Tool from './assets/js/Tool'
import Cookie from 'js-cookie';
import MD5 from 'js-md5'
import Moment from 'moment';
import 'moment/locale/zh-cn';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/global.css";
import "./assets/css/video.css";
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'



Vue.use(Antd)


// axios 配置
axios.defaults.timeout = 20000

axios.defaults.baseURL =  Config.baseUrl;
axios.defaults.baseURL1 = Config.baseUrl1;
axios.defaults.baseURL2 = Config.baseUrl2;
// axios.defaults.headers['spl-token'] = Cookie.get('xian-spl-token');

// http request 拦截器
let loadingInstance = null;
axios.interceptors.request.use(config => {
  config.headers['spl-token'] = Cookie.get('xian-spl-token');
  //   config.headers['spl-token'] = localStorage.getItem('xian-spl-token');
  loadingInstance = Loading.service({
    fullscreen: true,
    spinner: 'loading-logo',
    text: '加载中...'
  });
  return config;
})
// http response 拦截器
axios.interceptors.response.use(config => {
  console.log('response', config)
  // console.log("vueInstance: ", vueInstance)
  if (!config.data.login_api) {
    if (!config.data.is_login) {
      loadingInstance.close();
      vueInstance.$router.push({
        name: 'login'
      })
      return;
    }
  }
  loadingInstance.close();
  return config;
})
// 新增S
Vue.prototype.$post = function (url, data) {
  let _this = this;
  let promise = new Promise((resolve, reject) => {
    axios.post(url, data)
      .then((response) => {
        resolve(response.data)
      }).catch((error) => {
        Vue.prototype.$message.error('发生错误...');
      });
  });
  return promise;
};

Vue.prototype.$get = function (url, data) {
  let _this = this;
  let promise = new Promise((resolve, reject) => {
    axios.get(url, data)
      .then((response) => {
        resolve('dfhgfjgf', response.data)
      }).catch((error) => {
        console.log('----error', error)
        reject(error)

        Vue.prototype.$message.error('发生错误...');
      });
  });
  return promise;
};
// 新增E
// 定义全局过滤器，大家都能用
Vue.filter('formatDate', function (val) {
  return Moment(val).format('YYYY-MM-DD HH:mm:ss');
})


function closeLoading() {
  loadingInstance.close()
}

Vue.prototype.axios = axios;
Vue.prototype.$echarts = Eachats;
Vue.prototype.$Tool = Tool;
Vue.prototype.MD5 = MD5;
Vue.prototype.closeLoading = closeLoading;
Vue.use(ElementUI);

var vueInstance = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')





// WEBPACK FOOTER //
// ./src/main.js